export default "__VITE_ASSET__BQqOJiZ___"